module.exports = __webpack_public_path__ + "img/dea-formazione-ico-fisica.cf94cd93.svg";